import { render, staticRenderFns } from "./RicercaUtilizzo.vue?vue&type=template&id=053d471c&scoped=true&"
import script from "./RicercaUtilizzo.vue?vue&type=script&lang=js&"
export * from "./RicercaUtilizzo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d471c",
  null
  
)

export default component.exports